import { create } from "zustand";

type ModalState<T> =
  | {
      isOpen: true;
      payload: T;
    }
  | {
      isOpen: false;
      payload: null;
    };

type ModalsStore = {
  brainstormSaveDraftModal: ModalState<{
    id: string;
    title: string;
    description: string;
  }>;
  openModal: <T extends keyof Omit<ModalsStore, "openModal" | "closeModals">>(
    modal: T,
    payload: ModalsStore[T]["payload"]
  ) => void;
  closeModals: (
    modal: keyof Omit<ModalsStore, "openModal" | "closeModals">
  ) => void;
};

export const useModalsStore = create<ModalsStore>(set => ({
  brainstormSaveDraftModal: {
    isOpen: false,
    payload: null
  },
  openModal: (modal, payload) => {
    set({
      [modal]: {
        isOpen: true,
        payload
      }
    });
  },
  closeModals: modal => {
    set({
      [modal]: {
        isOpen: false,
        payload: null
      }
    });
  }
}));
